import { render, staticRenderFns } from "./TablesPay.vue?vue&type=template&id=06c27578&scoped=true&"
import script from "./TablesPay.vue?vue&type=script&lang=js&"
export * from "./TablesPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c27578",
  null
  
)

export default component.exports